import {IPostAction} from './IPostAction';
import {IWindowProxy} from '../services/IWindowProxy';

export class NavigationLayoutAction implements IPostAction {
    constructor(private windowProxy: IWindowProxy, private searchParams: URLSearchParams) {
    }

    public execute(data: Record<string, any>): void {
        const paddings = this.searchParams.get('viewportpadding');
        if (paddings) {
            const [x, y, pTop, pRight, pBottom, pLeft] = paddings.split(',').map(n => parseInt(n, 10) || 0);
            this.windowProxy.postMessage({
                eventName: 'lemonstand.navigation.layout.update',
                data: {x, y, pTop, pRight, pBottom, pLeft},
            });
        }
    }
}
